import React from "react";
import {
  Card,
  Divider,
  Form,
  Header,
  Item,
  List,
  TextArea
} from "semantic-ui-react";
import Content from "../../Content";
import PathView from "../../PathView";
import Steps from "./Steps";
import withSingleFlightImportData from "./withSingleFlightImportData";
import { dateTimeFormat } from "../../../utils/dateFormat";

function SingleImportSummary({ match, flightScheduleImport }) {
  if (!flightScheduleImport) {
    return null;
  }
  let logs = JSON.parse(flightScheduleImport.executionLogs);
  if (Array.isArray(logs)) {
    logs.join("\n");
  }
  return (
    <Content fullWidth>
      <PathView
        paths={[
          {
            name: "Flight Schedules Import",
            path: "/maintenance/flight-schedules-import"
          },
          { name: match.params.id }
        ]}
      />
      <Card fluid>
        <Card.Content textAlign="left">
          <Card.Header>Flight Schedules Import</Card.Header>
          <Item>
            <Item.Content>
              <Item.Description>
                <List>
                  <List.Item>
                    <List.Content>
                      file name: {flightScheduleImport.filename}
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      created: {dateTimeFormat(flightScheduleImport.createdAt)}
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content>
                      last update:{" "}
                      {dateTimeFormat(flightScheduleImport.updatedAt)}
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Content
                      style={{ display: "inline-flex", alignItems: "center" }}
                    >
                      Status:&nbsp;&nbsp;
                      <Steps step={flightScheduleImport.executionStatus} />
                    </List.Content>
                  </List.Item>
                </List>
              </Item.Description>
            </Item.Content>
          </Item>
          <Divider />
          <Header as="h4" content="Pipeline log" icon="tasks" />
          <Form>
            <TextArea disabled autoHeight defaultValue={logs} />
          </Form>
        </Card.Content>
      </Card>
    </Content>
  );
}

export default withSingleFlightImportData(SingleImportSummary);



// WEBPACK FOOTER //
// ./src/component/Maintenance/ImportFlights/SingleImportSummary.js